export const HOST = "https://onlymassage.io";
